import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { App } from "./app";
export function Root() {
  return React.createElement(Router, null, React.createElement(App, null));
}